export default "__VITE_ASSET__CZRGTERz__"